import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts'

import { resolveRowKeyForDataKey } from '@/utils/table-cell-value'

interface BarChartComponentProps {
  data: Array<Record<string, any>>
  xKey: string
  yKey: string
  title?: string
  color?: string
  horizontal?: boolean
  loading?: boolean
}

export function BarChartComponent({
  data,
  xKey,
  yKey,
  title,
  color = '#10b981',
  horizontal = false,
  loading = false,
}: BarChartComponentProps) {

  if (loading) {
    return (
      <div className="bg-white border rounded-lg p-6">
        {title && <h3 className="text-lg font-semibold mb-4">{title}</h3>}
        <div className="h-[300px] flex items-center justify-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-600"></div>
        </div>
      </div>
    )
  }

  if (!data || data.length === 0) {
    return (
      <div className="bg-white border rounded-lg p-6">
        {title && <h3 className="text-lg font-semibold mb-4">{title}</h3>}
        <div className="h-[300px] flex items-center justify-center text-gray-500">
          No hay datos disponibles
        </div>
      </div>
    )
  }

  const sample = data[0] as Record<string, unknown>
  const resolvedXKey = resolveRowKeyForDataKey(sample, xKey)
  const resolvedYKey = resolveRowKeyForDataKey(sample, yKey)

  return (
    <div className="bg-white border rounded-lg p-6">
      {title && <h3 className="text-lg font-semibold mb-4">{title}</h3>}

      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={data} layout={horizontal ? 'vertical' : 'horizontal'}>
          <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
          <XAxis
            type={horizontal ? 'number' : 'category'}
            dataKey={horizontal ? undefined : resolvedXKey}
            stroke="#6b7280"
            style={{ fontSize: '12px' }}
          />
          <YAxis
            type={horizontal ? 'category' : 'number'}
            dataKey={horizontal ? resolvedXKey : undefined}
            stroke="#6b7280"
            style={{ fontSize: '12px' }}
            tickFormatter={(value) =>
              typeof value === 'number' ? value.toLocaleString('es-ES') : value
            }
          />
          <Tooltip
            contentStyle={{
              backgroundColor: '#fff',
              border: '1px solid #e5e7eb',
              borderRadius: '8px',
              padding: '12px',
            }}
            formatter={(value: number) => value.toLocaleString('es-ES')}
          />
          <Legend />
          <Bar dataKey={resolvedYKey} fill={color} radius={[4, 4, 0, 0]} name={resolvedYKey} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  )
}
